import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { LogOut, Mail, Phone, Globe, BarChart3 } from 'lucide-react';

export const AdminPanel = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSignOut = async () => {
    setLoading(true);
    await supabase.auth.signOut();
    navigate('/admin/login');
  };

  const stats = [
    { label: 'Formularz kontaktowy', value: 'Aktywny', icon: Mail, color: 'text-green-400' },
    { label: 'Kanał e-mail', value: 'Resend', icon: Mail, color: 'text-blue-300' },
    { label: 'Telefon', value: '507 456 292', icon: Phone, color: 'text-blue-300' },
    { label: 'E-mail kontaktowy', value: 'biuro@marketengine.pl', icon: Globe, color: 'text-blue-300' },
  ];

  return (
    <div className="min-h-screen bg-slate-950 p-8">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-bold text-gradient text-glow">Panel Administracyjny</h1>
          <button
            onClick={handleSignOut}
            disabled={loading}
            className="flex items-center space-x-2 px-4 py-2 bg-red-500/20 text-red-300 rounded-lg border border-red-500/30 hover:bg-red-500/30 transition-all disabled:opacity-50"
          >
            <LogOut className="w-4 h-4" />
            <span>Wyloguj</span>
          </button>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 mb-8">
          <div className="flex items-center space-x-3 mb-4">
            <BarChart3 className="w-6 h-6 text-blue-300" />
            <h2 className="text-xl font-semibold text-white">Status systemu</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {stats.map((stat, i) => {
              const Icon = stat.icon;
              return (
                <div key={i} className="bg-white/5 rounded-lg p-4 border border-white/10 flex items-center space-x-3">
                  <Icon className={`w-5 h-5 ${stat.color}`} />
                  <div>
                    <p className="text-blue-200/80 text-sm">{stat.label}</p>
                    <p className="text-white font-semibold">{stat.value}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10">
          <h2 className="text-xl font-semibold text-white mb-4">Wiadomości z formularza</h2>
          <p className="text-blue-200/80">
            Wiadomości z formularza kontaktowego są wysyłane bezpośrednio na adres e-mail przez usługę Resend.
            Nie są przechowywane w bazie danych.
          </p>
        </div>
      </div>
    </div>
  );
};
